import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import { Field, useFormikContext } from "formik";
import EyeIcon from "../../assets/icons/alert-management-icons/eye-icon";
import CheckBox from "../forms/check-box-field";
import Preview from "./preview";

// Move Component1 OUTSIDE of CommunicationInputData
const AttachmentCheckbox = ({ lableName, values, index, setFieldValue, disabled }) => {
  console.log("............clicked", lableName);
  
  const attachmentsStr = values?.notificationCommunicationData?.[index]?.attachments || "";
  const attachmentsArr = attachmentsStr
    .split(",")
    .map((a) => a.trim())
    .filter(Boolean);

  const isChecked = attachmentsArr.includes(lableName);

  const handleCheckboxChange = (e) => {
    console.log("Checkbox changed:", e.target.checked);
    let updatedList = [];

    if (e.target.checked) {
      updatedList = [...new Set([...attachmentsArr, lableName])];
    } else {
      updatedList = attachmentsArr.filter((item) => item !== lableName);
    }

    setFieldValue(
      `notificationCommunicationData[${index}].attachments`,
      updatedList.join(", ")
    );
  };

  return (
    <div className="flex flex-row w-full items-center gap-2 p-3 rounded-lg bg-[var(--alert-management-variable-bg)]">
      <input
        type="checkbox"
        checked={isChecked}
        disabled={disabled}
        onChange={handleCheckboxChange}
        className="custom-checkbox form-check-input ml-[3px]"
      />
      <label className="text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)]">
        {lableName}
      </label>
    </div>
  );
};

function CommunicationInputData({
  activeTab,
  setShowPreview,
  setActiveTabData,
  disabled,
}) {
  const { values, setFieldValue } = useFormikContext();

  let index = 0;
  let textAreaPlaceholder = "";
  let textAreaLabel = "";
  let subjectLable = "";
  let body = "";
  let subject = "";
  const openPreview = () => setShowPreview(true);
  const dynamicHint = "Use {variable_name} for dynamic content";
  
  if (activeTab === "Email") {
    index = 0;
    textAreaPlaceholder = "Enter description";
    textAreaLabel = "Email Content";
    subjectLable = "Email Subject";
  } else if (activeTab === "SMS") {
    index = 1;
    textAreaPlaceholder = "Message here";
    textAreaLabel = "Message Content";
  } else if (activeTab === "WhatsApp") {
    index = 2;
    textAreaPlaceholder = "Message here";
    textAreaLabel = "Message Content";
  } else if (activeTab === "Push Notification") {
    index = 3;
    textAreaPlaceholder = "Enter description";
    textAreaLabel = "Message Content";
    subjectLable = "Push Title ";
  }

  if (activeTab === "Email" || activeTab === "Push Notification") {
    subject = values.notificationCommunicationData[index].subject;
  } else subject = values.notificationCommunicationData[index]?.template_name;
  
  let data = {
    subject: subject,
    body: values.notificationCommunicationData[index]?.body,
  };

  useEffect(() => {
    setActiveTabData(data);
  }, [values, activeTab]);

  if (activeTab === "") {
    return (
      <div className="flex  grow basis-[73%] gap-6  flex-col border   p-[25px] rounded-[var(--alert-management-border-radius)] border-[var(--alert-management-border-color)]">
        <label className="text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-title-fw)]">
          Communication channels are not selected
        </label>
      </div>
    );
  } else {
    return (
      <div
        id="second-div"
        className="flex  grow basis-[73%] gap-6  flex-col border    p-[25px] rounded-[var(--alert-management-border-radius)] border-[var(--alert-management-border-color)]"
      >
        <div className="flex flex-col gap-6 ">
          <label className="text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-title-fw)]">
            {activeTab === "Email"
              ? "Email Template Configuration"
              : activeTab === "SMS"
              ? "SMS Template Configuration"
              : activeTab === "WhatsApp"
              ? "Whatsapp Template Configuration"
              : activeTab === "Push Notification"
              ? "Push Notification Template Configuration"
              : ""}
          </label>
          
          <div className="flex flex-row items-center  justify-between w-full">
            <InputField
              errMsgContainerClass="hidden"
              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
              parentClass="flex  flex-col gap-2 w-full align-end "
              name={`notificationCommunicationData[${index}].template_name`}
              placeholder="Enter name"
              label="Template Name"
              isDisabled={disabled}
              containerClass="w-[460px] h-min"
              defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
            />
            <div
              onClick={openPreview}
              className="cursor-pointer p-[10px] w-min items-center flex flex-row gap-[10px] border border-[var(--alert-management-nav-text-color)] rounded-[var(--alert-management-preview-border-radius)]"
            >
              <EyeIcon />
              <span className="text-[var(--alert-management-nav-text-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                Preview
              </span>
            </div>
          </div>
          
          {(activeTab === "Email" || activeTab === "Push Notification") && (
            <div className="flex flex-col gap-2">
              <InputField
                errMsgContainerClass="hidden"
                labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                parentClass="flex  flex-col gap-2 w-full align-end "
                name={`notificationCommunicationData[${index}].subject`}
                placeholder="Enter Title"
                label={subjectLable}
                isDisabled={disabled}
                containerClass="w-full h-min"
                defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
              />
              {/* <label className={`text-[length:var(--alert-management-variable-fs)] font-[var(--alert-management-variable-fw)] text-[var(--alert-management-info-text-color)]`}>
                {dynamicHint}
              </label> */}
            </div>
          )}
          
          <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-row items-center justify-between w-full">
              <label className={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}>
                {textAreaLabel}
              </label>
              <div className="flex flex-row items-center gap-1">
                <input
                  checked={true}
                  disabled={true}
                  type="checkbox"
                  className="custom-checkbox form-check-input ml-[3px]"
                />
                <label className={`text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)]`}>
                  HTML
                </label>
              </div>
            </div>
            <Field
              as="textarea"
              placeholder={textAreaPlaceholder}
              disabled={disabled}
              name={`notificationCommunicationData[${index}].body`}
              className={`${
                disabled ? "cursor-not-allowed" : ""
              } text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-input-fw)] min-h-[104px] border border-[var(--alert-management-input-border-color)] rounded-lg w-full p-3 focus:outline-none focus:border-[var(--alert-management-input-border-color)] focus:text-[var(--alert-management-label-fs)] focus:bg-inherit`}
            />
            {/* <label className={`text-[length:var(--alert-management-variable-fs)] font-[var(--alert-management-variable-fw)] text-[var(--alert-management-info-text-color)]`}>
              {dynamicHint}
            </label> */}
          </div>
          
          <div className="flex flex-col gap-2 w-full">
            <label className={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}>
              Attachments
            </label>
            <div className="grid grid-cols-3 gap-3">
              {console.log("=====+++++=====clicked")}
              
              {/* Now using the external AttachmentCheckbox component with proper keys */}
              <AttachmentCheckbox 
                key="Invoice Summary"
                lableName={`${values.notificationData.transaction_type} attachment`}
                values={values}
                index={index}
                setFieldValue={setFieldValue}
                disabled={disabled}
              />
              {/* <AttachmentCheckbox 
                key="Payment Confirmation"
                lableName="Payment Confirmation"
                values={values}
                index={index}
                setFieldValue={setFieldValue}
                disabled={disabled}
              />
              <AttachmentCheckbox 
                key="Purchase Order"
                lableName="Purchase Order"
                values={values}
                index={index}
                setFieldValue={setFieldValue}
                disabled={disabled}
              />
              <AttachmentCheckbox 
                key="Refund Notice"
                lableName="Refund Notice"
                values={values}
                index={index}
                setFieldValue={setFieldValue}
                disabled={disabled}
              />
              <AttachmentCheckbox 
                key="Billing Statement"
                lableName="Billing Statement"
                values={values}
                index={index}
                setFieldValue={setFieldValue}
                disabled={disabled}
              /> */}
              
             
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CommunicationInputData;